import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { ClinicalApproachFormValues } from "./interface";
import {
  TREATMENT_MODALITY_OPTIONS,
  TREATMENT_MODALITY_RATIONALE_OPTIONS,
  getLabelFromOptions,
} from "./constants";

interface ViewFieldsProps {
  formValues: ClinicalApproachFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Treatment modality"
        value={getLabelFromOptions(TREATMENT_MODALITY_OPTIONS, formValues.treatmentModality)}
      />
      <LabeledText
        label="Treatment modality rationale"
        value={
          formValues.treatmentModality
            ? getLabelFromOptions(TREATMENT_MODALITY_RATIONALE_OPTIONS, formValues.treatmentModalityRationale)
            : ""
        }
      />
      <LabeledText label="Generalization plan" value={formValues.generalizationPlan} />
      <LabeledText label="Maintenance plan" value={formValues.maintenancePlan} />
    </Grid>
  );
};

export default ViewFields;
